import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import sweetAlert, {
sweetStatusAlert,
sweetConfirmAlert
} from "../../../components/common/SweetAlert.js";
import { appConfigService } from "../../../service/settings/manage/app_config.service.js";
import Spinner from "react-bootstrap/Spinner";
import "../../../components/admin/css/common.css";
import {
Table,
TableHead,
TableRow,
TableBody,
TableCell
} from "@mui/material";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import SimpleReactValidator from "simple-react-validator";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import config from '../../../helper/config.js';
import {customerConstants} from "../../../helper/constants.js";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const getCustomerFeatureFlag = () => {
return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
case customerConstants.EXO_CUSTOMER1:
    break;
case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
        color: "var(--maincolor-cmc)",
        backgroundColor: "#E5F5FF",
        borderColor: "transparent",
    };
    addBtnStyle = {
        color: "#fff",
        backgroundColor: "var(--maincolor-cmc)",
        borderColor: "transparent",
    };
    break;
default:
    break;
}

export default class ManageAppConfig extends Component {
constructor(props) {
    super(props);
    this.createValidationsInstance();
    this.state = {
        showModal: false,
        appConfigs: [],
        name: "",
        value: "",
        status: 1,
        description: "",
        app_config_id: "",
        modalType: false,
        search_val: "",
        isLoading: true,
        isSpinnerLoading: false,
        isModified: false,
        limit: 10, // Set the desired limit
        offset: 0, // Set the desired offset
        search_term: "",
        sort_column: "AppConfigID",
        sort_direction: "ASC",
        totalAppConfigs: 10,
        currentPage: 0,
        editVisibility: true,
        addVisibility: true,
        deleteVisibility: true,
        allStatuses: [
            {
              id: 1,
              name: "Active",
            },
            {
              id: 0,
              name: "Inactive",
            },
        ],
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);

    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fecthAllAppConfigData, 2000);
}

resetFormFields = () => {
    this.setState({
        name: "",
        value: "",
        status: "",
        description: "",
        app_config_id: "",
    });
};

componentDidMount() {
    this.fecthAllAppConfigData();
}

createValidationsInstance() {
    this.validator = new SimpleReactValidator();
}

fecthAllAppConfigData() {
    const { limit, offset, search_term, sort_column, sort_direction } = this.state;
    appConfigService.getAll(limit, offset, search_term, sort_column, sort_direction)
    .then((response) => {
        if (response.success) {
        this.setState({
            appConfigs: response.data.app_configs,
            totalAppConfigs: parseInt(response.data.total_count),
        });
        } else {
        sweetStatusAlert(
            "Failed!",
            "Error fetching app configs. Please refresh the screen!",
            "error"
        );
        }
    })
    .catch((error) => {
        sweetStatusAlert(
        "Failed!",
        "Error fetching app configs. Please refresh the screen!",
        "error"
        );
    })
    .finally(() => {
        this.setState({ isLoading: false, isSpinnerLoading: false });
    });
}

handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
    {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage,
    },
    () => {
        this.fecthAllAppConfigData();
    }
    );
};

handleSortChange = (sort_column) => {
    // If the same column is clicked, toggle the sort direction
    const { sort_column: currentSortColumn, sort_direction } = this.state;
    const newSortDirection =
        currentSortColumn === sort_column && sort_direction === "ASC"
        ? "DESC"
        : "ASC";

    this.setState(
        {
            sort_column,
            sort_direction: newSortDirection,
            offset: 0, // Reset offset when changing sorting
            currentPage: 0,
            isLoading: true,
        },
        () => {
            this.fecthAllAppConfigData();
        }
    );
};

handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
    {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage
    },
    () => {
        this.fecthAllAppConfigData();
    }
    );
};

handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
    {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
    },
    () => {
        this.fecthAllAppConfigData();
    }
    );
};

handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
    this.setState(
        {
        search_term,
        isLoading: true,
        offset: 0,
        currentPage: 0,
        searchError: false,
        },
        () => {
        this.debouncedHandleSearch();
        }
    );
    } else {
    this.setState({ search_term, searchError: true });
    }
};

toggleAppConfigModal = (modalType) => {
    this.modalType = modalType;
    this.setState((prevState) => ({
     showModal: !prevState.showModal,
    }));
};

toggleUpdateAppConfigModal = (app_config_id, name, value, status, description, modalType) => {
    this.setState((prevState) => ({
        showModal: !prevState.showModal,
        app_config_id: app_config_id,
        name: name,
        value: value,
        status: status,
        description: description,
        modalType: modalType,
    }));
};

handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
};

handleChangeStatus = (event) => {
    event.preventDefault();
    this.setState({ status: event.target.value});
};

handleSweetAlert = (modalType, modalVisibility) => {
    if (this.state.isModified) {
        sweetAlert().then((response) => {
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.modalType = false;
            this.setState(() => ({
            [modalVisibility]: response,
            isModified: false,
            }));
        });
    } else {
        this.validator.hideMessages();
        this.validator.purgeFields();
        this.resetFormFields();
        if (modalType) this.toggleAppConfigModal(false);
        else this.toggleUpdateAppConfigModal();
    }
};

//Handle Edit Submit
handleEditSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.forceUpdate();
    } 
    else 
    {
        this.setState({ isSpinnerLoading: true });
        const appConfigItem = {
            Name: this.state.name,
            Value: this.state.value,
            Status: parseInt(this.state.status),
            Description: this.state.description,
        };
        const appConfigID = this.state.app_config_id;

        appConfigService.updateAppConfig(appConfigItem, appConfigID)
            .then((response) => {
            if (response.success) {
                this.setState({ isSpinnerLoading: false });
                this.toggleAppConfigModal();
                sweetStatusAlert(
                    "Success!",
                    "App config information updated successfully!",
                    "success"
                );
                this.validator.hideMessages();
                this.validator.purgeFields();
                this.resetFormFields();
                this.fecthAllAppConfigData();
            }else {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", response.message, "error");
            }
            })
            .catch((error) => {
            this.setState({ isSpinnerLoading: false });
            sweetStatusAlert(
                "Failed!",
                "Unable to update the app config information",
                "error"
            );
            });
    }
};

//add new App Config
handleSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.forceUpdate();
    } 
    else 
    {
        this.setState({ isSpinnerLoading: true });
        const { name, value, status, description } = this.state;
        const newAppConfigItem = { 
            Name: name, 
            Value: value,
            Status: status,
            Description: description,
        };

        appConfigService.addAppConfig(newAppConfigItem)
            .then((response) => {
            if (response.success) {
                sweetStatusAlert("Success!", response.message.success, "success");
                this.validator.hideMessages();
                this.validator.purgeFields();
                this.resetFormFields();
                this.toggleAppConfigModal(false);
                this.fecthAllAppConfigData();
            } else {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", response.message, "error");
            }
            })
            .catch((err) => {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", "Unable to create new app config", "error");
            });
    }
};

handleDeleteAppConfig = (id) => {
    sweetConfirmAlert()
        .then(async () => {
            this.setState({ isSpinnerLoading: true });
            await appConfigService.deleteAppConfig(id)
                .then((response) => {
                    this.setState({ isSpinnerLoading: false });
                    if (response.success) {
                        sweetStatusAlert("Success!", response.message.success, "success");
                        this.fecthAllAppConfigData();
                    } else {
                        sweetStatusAlert("Failed!", response.message, "error");
                    }
                })
                .catch(() => {
                    this.setState({ isSpinnerLoading: false });
                    sweetStatusAlert("Oops!", "Error while deleting the app config", "info");
                });
        })
        .catch(() => {
            console.log("Deletion cancelled by user");
        });
};

render() {
    const {
        limit,
        appConfigs,
        totalAppConfigs,
        isLoading,
        currentPage,
        isSpinnerLoading,
        editVisibility,
        addVisibility,
        deleteVisibility,
    } = this.state;
    return (
    <>
        <ContentWrapper>
        <div className="row justify-content-between align-items-center py-5 mb-3">
            <div className="col-md-6 col-6">
            <h3 className="text-nowrap">Manage App Config</h3>
            </div>
            <div>
            {addVisibility && (
                <Button
                    className="insert-btn"
                    variant="primary"
                    onClick={() => this.toggleAppConfigModal(true)}
                >
                    Add App Config
                </Button>
            )}
            </div>
        </div>
        <div>
            <Form.Group controlId="exampleForm.ControlInput1" className="mb-2">
            <Form.Control
                type="text"
                placeholder="Search"
                onChange={this.handleSearch}
                isInvalid={this.state.searchError}
                // style={{ width: "18%" }}
                className="col-md-3 col-12"
            />
            {this.state.searchError && (
                <Form.Control.Feedback type="invalid">
                    Invalid input
                </Form.Control.Feedback>
            )}
            </Form.Group>
            {isSpinnerLoading && (
            <PageSpinner id="show" text="Loading, Please wait!" />
            )}
            {isLoading ? (
            <div
                className="loading-container"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "75vw",
                    height: "90vh",
                }}
            >
                <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
                </Spinner>
            </div>
            ) : appConfigs.length > 0 ? (
            <div style={{ width: "80vw", height: "90vh", overflow: "auto" }}>
                <Table>
                <TableHead>
                    <TableRow>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("AppConfigID")}
                    >
                        AppConfigID{" "}
                        {this.state.sort_column === "AppConfigID" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("Name")}
                    >
                        Name{" "}
                        {this.state.sort_column === "Name" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("Value")}
                    >
                        Value{" "}
                        {this.state.sort_column === "Value" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("Description")}
                    >
                        Description{" "}
                        {this.state.sort_column === "Description" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("Status")}
                    >
                        Status{" "}
                        {this.state.sort_column === "Status" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    {(editVisibility || deleteVisibility) && (
                        <TableCell className="thead">Actions</TableCell>
                    )}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {appConfigs.map((appConfigItem) => (
                    <TableRow key={appConfigItem.AppConfigID}>
                        <TableCell className="tData">
                            {appConfigItem.AppConfigID}
                        </TableCell>
                        <TableCell className="tData">
                            {appConfigItem.Name}
                        </TableCell>
                        <TableCell className="tData">
                            {appConfigItem.Value}
                        </TableCell>
                        <TableCell className="tData">
                            {appConfigItem.Description}
                        </TableCell>
                        <TableCell className="tData">
                            {appConfigItem.Status === 1 ? "Active" : "Inactive"}
                        </TableCell>
                        {(editVisibility || deleteVisibility) && (
                        <TableCell>
                            <div className="btn-group">
                            {editVisibility && (
                                <Button
                                    onClick={() =>
                                        this.toggleUpdateAppConfigModal(
                                            appConfigItem.AppConfigID,
                                            appConfigItem.Name,
                                            appConfigItem.Value,
                                            appConfigItem.Status,
                                            appConfigItem.Description,
                                            false
                                        )
                                    }
                                    className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                                    title="Edit Details"
                                />
                            )}
                            {/* {deleteVisibility && (
                                <Button
                                    onClick={() =>
                                        this.handleDeleteAppConfig(
                                            appConfigItem.AppConfigID
                                        )
                                    }
                                    className="btn btn-icon btn-danger btn-sm m-1 delete-assement-btn flaticon-delete"
                                    title="Delete"
                                />
                            )} */}
                            </div>
                        </TableCell>
                        )}
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
                <MaterialCustomTablePagination
                    totalCount = {totalAppConfigs}
                    currentPage = {currentPage}
                    limit = {limit}
                    handlePageChange = {this.handlePageChange}
                    handleRowsPerPageChange = {this.handleRowsPerPageChange}
                    handlePageOffsetChange = {this.handlePageOffsetChange}
                    offset = {this.state.offset}
                    rowsPerPageOptions={[5, 10, 20]}
                />
            </div>
            ) : (
            <div
                className="text-center mb-5 mt-10"
                style={{ height: "90vh" }}
            >
                <label>No App Configs Available!</label>
            </div>
            )}
        </div>
        </ContentWrapper>

        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showModal}
            onHide={() => this.handleSweetAlert(this.modalType, "showModal")}
        >
        {this.modalType === true ? (
            <div>
            <Modal.Header closeButton>
                <Modal.Title>Create New App Config</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Name*</Form.Label>
                    <Form.Control
                        type="text"
                        name="name"
                        placeholder="Type name here..."
                        value={this.state.name}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "name",
                        this.state.name,
                        "required|max:128",
                        {
                            className: "text-danger",
                            messages: {
                                max: "The app config name should not be greater than 128 characters.",
                                required: "The app config name field is required.",
                            },
                        }
                    )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Value*</Form.Label>
                    <Form.Control
                        type="text"
                        name="value"
                        placeholder="Type value here..."
                        value={this.state.value}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "value",
                        this.state.value,
                        "required|max:128",
                        {
                            className: "text-danger",
                            messages: {
                                max: "The app config value should not be greater than 128 characters.",
                                required: "The app config value field is required.",
                            },
                        }
                    )}
                    </Form.Group>
                </Row>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Description*</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={2} 
                        type="text"
                        name="description"
                        placeholder="Type description here..."
                        value={this.state.description}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "description",
                        this.state.description,
                        "required|alpha_space|max:1024",
                        {
                            className: "text-danger",
                            messages: {
                                max: "app config description should not be greater than 1024 characters.",
                                alpha_space:"app config description must have valid characters.",
                                required: "app config description field is required.",
                            },
                        }
                    )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Status*</Form.Label>
                    <Form.Select
                        aria-label="Default select example"
                        name="status"
                        onChange={this.handleChangeStatus}
                        value={this.state.status}
                        disabled={true}
                    >
                        <option value="">Select</option>
                        {this.state.allStatuses.map((status) => (
                        <option key={status.id} value={status.id}>
                            {status.name}
                        </option>
                        ))}
                    </Form.Select>
                    <div style={{ color: "red" }}>
                        {this.validator.message("status", this.state.status, "required")}
                    </div>
                    </Form.Group>
                </Row>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="primary"
                    style={addBtnStyle}
                    onClick={this.handleSubmit}
                >
                    Save changes
                </Button>
                <Button
                    id="modal-close-button"
                    style={closeBtnStyle}
                    onClick={() =>
                        this.handleSweetAlert(this.modalType, "showModal")
                    }
                >
                    Close
                </Button>
            </Modal.Footer>
            </div>
        ) : (
            <div>
            <Modal.Header closeButton>
                <Modal.Title>Update {this.state.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Value*</Form.Label>
                    <Form.Control
                        type="text"
                        name="value"
                        placeholder="Type value here..."
                        value={this.state.value}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "value",
                        this.state.value,
                        "required|max:128",
                        {
                            className: "text-danger",
                            messages: {
                                max: "The app config value should not be greater than 128 characters.",
                                required: "The app config value field is required.",
                            },
                        }
                    )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Description*</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={2} 
                        type="text"
                        name="description"
                        placeholder="Type description here..."
                        value={this.state.description}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "description",
                        this.state.description,
                        "required|alpha_space|max:1024",
                        {
                            className: "text-danger",
                            messages: {
                                max: "app config description should not be greater than 1024 characters.",
                                alpha_space:"app config description must have valid characters.",
                                required: "app config description field is required.",
                            },
                        }
                    )}
                    </Form.Group>
                </Row>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Status*</Form.Label>
                    <Form.Select
                        aria-label="Default select example"
                        name="status"
                        onChange={this.handleChangeStatus}
                        value={this.state.status}
                        disabled={true}
                    >
                        <option value="">Select</option>
                        {this.state.allStatuses.map((status) => (
                        <option key={status.id} value={status.id}>
                            {status.name}
                        </option>
                        ))}
                    </Form.Select>
                    <div style={{ color: "red" }}>
                        {this.validator.message("status", this.state.status, "required")}
                    </div>
                    </Form.Group>
                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="modal-btn"
                    variant="primary"
                    style={addBtnStyle}
                    onClick={this.handleEditSubmit}
                >
                    Save changes
                </Button>
                <Button
                    className="modal-btn"
                    id="modal-close-button"
                    style={closeBtnStyle}
                    onClick={() =>
                        this.handleSweetAlert(this.modalType, "showModal")
                    }
                >
                    Close
                </Button>
            </Modal.Footer>
            </div>
        )}
        </Modal>
    </>
    );
}
}
